module.exports = __webpack_public_path__ + "3bf5bda43c589e26c33f372b97031616.svg";